<template>
    <v-layout row>
        <v-flex xs12 sm12>
            <v-card class="elavation-1 transparent">
                <!--header toolbar-->
                <v-toolbar class="transparent" flat height="37">
                    <v-btn dark icon title="Back to My Teams" @click="$router.push('/company')">
                        <v-icon>arrow_back</v-icon>
                    </v-btn>                    
                    <v-spacer></v-spacer>
                    <help-link appId="company" pageId="timesheets" color="white"></help-link>
                    <v-menu left v-model="menu_status" offset-y > 
                        <template v-slot:activator="{ on }">
                            <v-btn color="primary" dark v-on="on">
                                &nbsp;&nbsp;CY {{selectedFiscalYear}}&nbsp;&nbsp;
                                <v-icon v-show="!menu_status">arrow_drop_down</v-icon>
                                <v-icon v-show="menu_status">arrow_drop_up</v-icon>
                            </v-btn>
                        </template>
                        <v-list dense>
                            <v-list-tile v-for="(item,index) in fiscal_years" :key="index" :title="`Calendar Year ${item.fiscalYear}`" @click="setSelectedYear(item.fiscalYear)">
                                <v-list-tile-title small>CY {{item.fiscalYear}}</v-list-tile-title>
                            </v-list-tile>
                        </v-list>
                    </v-menu>
                </v-toolbar>
                <v-progress-linear v-if="loading" indeterminate color="primary" height="3" class="mt-0"></v-progress-linear>
            </v-card>
            <v-card class="elavation-1 mt-5"> 
                <v-toolbar flat height="45px">
                    <div :class="isMobile?'wp-50 mb-10':'wp-30 mb-10'">
                        <v-text-field v-model="search" append-icon="search" label="Search date" single-line hide-details></v-text-field>
                    </div>                    
                    <v-spacer></v-spacer>
                    <span class="font-weight-bold">Select Cutoff Period</span>
                </v-toolbar>
                <v-data-table
                    :headers="isMobile ? headers_mobile: headers"
                    :items="timesheet_summary_filtered"
                    :loading="loading"
                    :rows-per-page-items="rowsPerPageItems"
                    :pagination.sync="paginationSync"
                >
                    <v-progress-linear v-slot:progress color="primary" indeterminate></v-progress-linear>
                    <template v-slot:items="props">
                        <tr @click="viewDetails(props.item)" class="clickable" title="Click to view timesheet for this period">
                            <td v-if="!isMobile">
                                <span class="font-weight-bold">{{props.item.cutOffPeriodDesc}}</span>
                            </td>
                            <td v-if="isMobile">{{ getCutoffCoverageDescription(props.item.cutOffStart, props.item.cutOffEnd) }}</td>
                            <td v-if="!isMobile">{{ props.item.cutOffStart | moment("YYYY-MM-DD") }}</td>
                            <td v-if="!isMobile">{{ props.item.cutOffEnd | moment("YYYY-MM-DD") }}</td>
                            <td>
                                <b :class="commonfn.getStatusColor(props.item.cutOffStatus)">{{commonfn.getStatusDescription(props.item.cutOffStatus)}}</b>
                            </td>
                        </tr>
                    </template>
                </v-data-table> 
            </v-card>
        </v-flex>
    </v-layout> 
</template>

<script>

import timesheetApi from '@/api/timesheet'
import commonfn from '@/common/functions'
import userPrefs from '@/helpers/user-prefs'
import rowsPerPageItems from '@/constants/rows-per-page'
import { getCutoffCoverageDescription } from '@/helpers/cutoff-format'

export default {     
    name: 'AllTeamsTimesheet',
    metaInfo: {
        title: 'All Teams Timesheet',
        meta: [
            { charset: 'utf-8' },
            { name: 'description', content: 'All Teams Timesheet' },
            { name: 'viewport', content: 'width=device-width, initial-scale=1' }
            ]
    },
    components: {
        'help-link': () => import('@/components/Common/HelpLink'),
    },   
    data () {
        const routeName = this.$route.name
        const savedSort = userPrefs.getSort(routeName)

        return {
            commonfn,
            rowsPerPageItems,
            getCutoffCoverageDescription,
            paginationSync: {
                rowsPerPage: userPrefs.getRowsPerPage(routeName),
                sortBy: savedSort.sortBy,
                descending: savedSort.descending,
            },
            selectedFiscalYear: userPrefs.getCalendarYear(routeName),
            error: false,
            errorMessage: '',
            loading: false,
            headers: [
                {text: 'Period',align: 'left',value: 'cutOffPeriodDesc', width: '10%', sortable:true},
                {text: 'Cutoff Start Date',align: 'left',value: 'cutoffStart', width: '10%', sortable:true},
                {text: 'Cutoff End Date',align: 'left',value: 'cutoffEnd', width: '10%', sortable:true},
                {text: 'Cutoff Status',align: 'left',value: 'status',  width: '10%', sortable:true}
            ],
            headers_mobile: [
                {text: 'Cutoff Period',align: 'left',value: 'cutoffStart', width: '10%', sortable:true},
                {text: 'Cutoff Status',align: 'left',value: 'status',  width: '10%', sortable:true}
            ],
            timesheet_summary: [],
            search: userPrefs.getSearchKeyword(routeName),
            menu_status: false,
        }
    },
    methods: {
        setSelectedYear(fiscalYear) {
            this.selectedFiscalYear = fiscalYear
            userPrefs.updateCalendarYear(this.$route.name, fiscalYear)
        },
        viewDetails(data) {
            this.$router.push(`timesheets/${data.cutOffId}`)
        }, 
        async getTimesheetSummary() {
            try {
                this.loading = true
                const response = await timesheetApi.getSummaryByCompany()     
                if (response && response.status == 200) {
                    this.timesheet_summary = response.data.summaryItems
                }
                this.loading = false
            }catch(error){
                this.error = true
                this.errorMessage = error
            }
        }, 
    },
    created() {
        //update header titles
        this.$root.$emit('setHeaderTitles', {
            display: true,
            headerTitle: '',
            headerPageTitle: 'All Employees Timesheets'
        })

        this.getTimesheetSummary()
    },
    watch: {
        'paginationSync.rowsPerPage'(newVal) {
            userPrefs.updateRowsPerPage(this.$route.name, newVal)
        },
        'paginationSync.sortBy'(newVal) {
            userPrefs.updateSort(this.$route.name, newVal, this.paginationSync.descending)
        },
        'paginationSync.descending'(newVal) {
            userPrefs.updateSort(this.$route.name, this.paginationSync.sortBy, newVal)
        },
        search(newVal) {
            userPrefs.updateSearchKeyword(this.$route.name, newVal)
        }
    },
    computed: {
        isMobile() {
            return window.innerWidth < 600
        },
        timesheet_summary_filtered() {
            var temp = this.timesheet_summary.filter(item => {
                return (item.fiscalYear==this.selectedFiscalYear && !item.cutOffPeriodDesc.includes('Upcoming'))
            })
            if (this.search) {
                temp = temp.filter(item => {
                    return ( item.cutOffStart.includes(this.search))
                })
            }
            return temp //.reverse()
        },
        fiscal_years() {
            if (this.$store.state.fiscalPeriods) {
                return this.$store.state.fiscalPeriods
            }
            return [{fiscalYear: new Date().getFullYear()}]
        }
    }
}
</script>